import angular from 'angular';

class checkIdGisModalCtrl {
  /* @ngInject */
  constructor() {}

  $onInit() {
    this.modalTitle = angular.copy(this.resolve.modalTitle);
    this.data = angular.copy(this.resolve.data);
    this.modalCancelButtonText = angular.copy(this.resolve.modalCancelButtonText);
    this.modalConfirmButtonText = angular.copy(this.resolve.modalConfirmButtonText);
  }

  cancel() {
    this.modalInstance.dismiss(this.data);
  }

  confirm() {
    this.modalInstance.close(this.data);
  }

  showConfirm() {
    return this.modalConfirmButtonText && this.modalConfirmButtonText.value;
  }
}

angular.module('app.principal').component('checkIdGisModal', {
  templateUrl: require('./check-id-gis-modal.html'),
  controller: checkIdGisModalCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
